module.exports = __webpack_public_path__ + "static/media/search.01412f96.svg";